<template>
    <Dialog
        :dialog="dialog"
        :visible="true"
        :mFormValue="formValue"
        :defaultModalVal="false"
        @closeDialog="closeDialog"
        @dialogCheck="dialogCheck"
        @getAdvanceValue="getAdvanceValue"
        :tableData="tableData"
        :closeOnClickModal="false"
        ref="Dialog"
    >
        <template slot='excFormMyCont'>
           <el-tabs v-model="activeName" @tab-click="handleClick" class="aging-tab">
            <el-tab-pane label="站点仓库配置" name="whConfig" class="aging-config">
                <station-table ref="agingStation" :tableData="customerAgingStationList" :formData="formValue"
                    :btnType="btnType" @change="elementChange"></station-table>
                <!-- <dialogTable
                    :tableData="customerAgingStationList"
                    :dialogTable="dialog.siteWhTable"
                    ref="dialogTable"
                    @dialogDelRow="dialogDelRow"
                    @change="elementChange"
                >
                    <template slot="myFooter">
                        <div class="tableFooter">
                            <el-button type="text" @click="addDialogRow" :disabled="!config.dialog.siteWhTable.btnActive">+ 添加明细</el-button>
                        </div>
                    </template>
                </dialogTable> -->
            </el-tab-pane>
            <el-tab-pane label="节点时效配置" name="agingConfig">
                <aging-config ref="agingConfig" :btnType="btnType" :config="config" :rowData="rowData" :customerAgingStationList="customerAgingStationListAndYS"
                    :customerAgingConfigDatailList.sync="customerAgingConfigDatailList" :agingStartTime="formValue.agingStartTime" :formData="formValue"></aging-config>
            </el-tab-pane>
        </el-tabs>
        </template>
    </Dialog>
</template>
<script>
import dayjs from 'dayjs';
import _ from 'lodash';
import Dialog from '../../../../components/dialog/dialog';
// import dialogTable from '../../../../components/dialog/dialogTable';
import AgingConfig from './AgingConfig';
import config from '../config.js';
import { getCustomerDetail, customerAdd, getTransferSite } from '../../../../api/timeManage';
import StationTable from './StationTable.vue';
export default {
    name: 'agingTableTab',
    components: { Dialog, AgingConfig, StationTable },
    props: {
        rowData: {
            type: Object,
            default: () => {
                return {};
            }
        },
        btnType: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            config: config,
            dialog: config.dialog,
            formValue: {
                distributionWhCode: '',
                distributionWhName: '',
                siteCode: '',
                siteName: '',
                whCode: '',
                whName: ''
            },
            customerAgingStationList: [],
            tableData: [],
            current: 0,
            tabList: [{ label: '站点仓库配置' }, { label: '节点时效配置' }],
            activeName: 'whConfig',
            customerAgingConfigDatailList: []
        };
    },
    computed: {
        customerAgingStationListAndYS() {
            const customerAgingStationList = _.clone(this.customerAgingStationList);
            if (['YS'].includes(this.formValue.orderType)) {
                const ysFristStation = this.customerAgingConfigDatailList.filter(c => +c.sortNo === 1 || !c.sortNo);
                customerAgingStationList.unshift({
                    sortNo: 1,
                    whCode: this.formValue.whCode || '',
                    whName: this.formValue.whName || '',
                    customerAgingConfigDatailList: ysFristStation
                });
            }
            return customerAgingStationList;
        }
    },
    methods: {
        handleClick() {},
        closeDialog(params, type) {
            this.$refs.Dialog.loading = false;
            if (params.mFormData && (['WEIGHT_AGING', 'VOLUME_AGING'].includes(params.mFormData.customerAgingType))) {
                if (params.mFormData.rangeFrom === undefined || params.mFormData.rangeTo === undefined) {
                    return this.$message.warning('时效类型为吨位时效、方量时效，范围（从、至）必填');
                }
            }
            if (params.mFormData && (['WEIGHT_AGING', 'VOLUME_AGING', 'CUSTOMER_AGING'].includes(params.mFormData.customerAgingType))) {
                if (params.mFormData.customerCode === undefined) {
                    return this.$message.warning('时效类型为吨位时效、方量、客户时效，客户必填');
                }
            }
            if (type === 'sure') {
                const formData = params.mFormData;
                if (new Date(formData.invalidTime) < new Date(formData.validTime)) {
                    return this.$message.warning('生效时间不能晚于失效时间');
                }
                const agingConfigDatailList = [];
                const customerAgingStationList = this.customerAgingStationList;
                // let totalElapsedTimeFlag = 0;
                let hour = (this.formValue.agingStartTime || '00:00:00').split(':')[0];
                hour = hour.indexOf('+') > -1 ? Number(hour.split('+')[1]) + 24 : Number(hour);
                this.customerAgingStationListAndYS.forEach(station => {
                    // if (station.totalElapsedTime < 0) { ++totalElapsedTimeFlag; }
                    station.customerAgingConfigDatailList && station.customerAgingConfigDatailList.forEach(c => {
                        const agingReqTime = (+c.agingReqHour || 0) + (+c.agingReqDay * 24 || 0);
                        agingConfigDatailList.push({
                            ...c,
                            sortNo: station.sortNo,
                            siteName: station.siteName,
                            siteCode: station.siteCode,
                            whName: station.whName,
                            whCode: station.whCode,
                            agingReqTime: agingReqTime,
                            agingHour: agingReqTime - hour
                        });
                    });
                });
                if (!agingConfigDatailList.length) {
                    return this.$message.warning('节点时效配置不能为空！');
                }
                let agingHourFlag = 0;
                let agingReqTimeFlag = 0;
                let statusFlag = 0;
                agingConfigDatailList.forEach(item => {
                    if (+item.agingHour < 0) { ++agingHourFlag; }
                    if (+item.agingReqTime <= 0) { ++agingReqTimeFlag; }
                    if (!item.status) { ++statusFlag; }
                });
                if (agingReqTimeFlag) { return this.$message.warning('节点时效配置 时效要求必须大于0！'); }
                if (statusFlag) { return this.$message.warning('节点时效配置 订单状态必填！'); }
                if (agingHourFlag) { return this.$message.warning('节点时效配置存在历时为负数的配置，请修改时效要求！'); }
                // if (totalElapsedTimeFlag) { return this.$message.warning('节点时效配置存在总历时为负数的配置，请修改时效要求！'); }
                delete customerAgingStationList.customerAgingConfigDatailList;
                const stationListNoData = [];
                customerAgingStationList.forEach((item, index) => {
                    if (!['YS'].includes(formData.orderType)) {
                        if (!item.whCode) { stationListNoData.push(item.sortNo); }
                    } else {
                        if (!item.whCode && index !== 0) { stationListNoData.push(item.sortNo); }
                    }
                });
                if (stationListNoData.length > 0) {
                    return this.$message.warning(`站点${stationListNoData.join('，')} 没有仓库信息`);
                }
                //  ['sendProvince','sendCity','sendDistrict','sendTown']
                const del = function(arr) {
                    const keys = Object.keys(formData);
                    keys.map(item => {
                        arr.map(child => {
                            if (item === child) {
                                delete formData[item];
                            }
                        });
                    });
                };
                del(['sendProvince', 'sendCity', 'sendDistrict', 'sendTown', 'receiveProvince', 'receiveCity', 'receiveDistrict', 'receiveTown']);
                if (params.mFormData.send && (params.mFormData.send instanceof Array)) {
                    if (formData.send.length === 4) {
                        [formData.sendProvinceCode, formData.sendCityCode, formData.sendDistrictCode, formData.sendTownCode] = params.mFormData.send;
                    } else if (formData.send.length === 3) {
                        [formData.sendProvinceCode, formData.sendCityCode, formData.sendDistrictCode] = params.mFormData.send;
                        formData.sendTownCode = '';
                    } else {
                        formData.sendProvinceCode = formData.sendCityCode = formData.sendDistrictCode = formData.sendTownCode = '';
                    }
                }
                // delete formData.send; // 删除改属性，保存接口报错时再点击报错会报错必填项不能为空的错

                if (params.mFormData.receive && (params.mFormData.receive instanceof Array)) {
                    if (formData.receive.length === 4) {
                        [formData.receiveProvinceCode, formData.receiveCityCode, formData.receiveDistrictCode, formData.receiveTownCode] = formData.receive;
                    } else if (formData.receive.length === 3) {
                        [formData.receiveProvinceCode, formData.receiveCityCode, formData.receiveDistrictCode] = formData.receive;
                        formData.receiveTownCode = '';
                    } else {
                        formData.receiveProvinceCode = formData.receiveCityCode = formData.receiveDistrictCode = formData.receiveTownCode = '';
                    }
                }
                formData.taskType = formData.taskType ? 'RDO' : '';
                // delete formData.receive; // 删除改属性，保存接口报错时再点击报错会报错必填项不能为空的错
                if (!formData.sendWhName) formData.sendWhCode = '';
                formData.validTime = formData.validTime ? dayjs(formData.validTime).format('YYYY-MM-DD') + ' 00:00:00' : '';
                formData.invalidTime = formData.invalidTime ? dayjs(formData.invalidTime).format('YYYY-MM-DD') + ' 23:59:59' : '';
                const obj = { ...formData, customerAgingStationList, customerAgingConfigDatailList: agingConfigDatailList };
                delete obj.updateUserCode;
                this.$refs.Dialog.loading = true;
                customerAdd(obj).then(res => {
                    this.$refs.Dialog.loading = false;
                    if (res && res.code === '0') {
                        this.$message.success('操作成功');
                        this.$emit('update:visible', false);
                        this.$emit('refresh');
                    }
                }).catch(() => { this.$refs.Dialog.loading = false; });
            } else {
                this.$emit('update:visible', false);
            }
        },
        // 纯运输订单站点从2开始
        getSortNo(index = 0) {
            const sortNo = index + (['YS', 'DO'].includes(this.formValue.orderType) ? 2 : 1);
            return sortNo;
        },
        dialogCheck(formValue, col) {
            this.formValue = { ...this.formValue, ...formValue };
            if (col && col.value === 'orderType') {
                this.customerAgingStationList.forEach((item, index) => {
                    item.sortNo = this.getSortNo(index);
                    if (index === 0 && !['YS'].includes(this.formValue.orderType)) {
                        item.transferFlagDisabled = false;
                    }
                });
                if (this.customerAgingStationList.length) {
                    if (this.formValue.whCode) { this.getFirstStation(); }
                    if (this.formValue.distributionWhCode) this.getSecondStation();
                }
            }
        },
        async elementChange(dataObj) {
            const rowData = this.customerAgingStationList[dataObj.data.$index];
            if (dataObj.key === 'siteName') {
                rowData.whName = rowData.whCode = '';
            }
        },
        getStationList(stationList, formValue) {
            let customerAgingStationList = stationList || [];
            // 非纯运输的第一条数据联动平台仓库，第二条数据联动分拨仓
            if (!['YS'].includes(formValue.orderType)) {
                if (!customerAgingStationList.length && (formValue.whCode || formValue.siteCode)) {
                    customerAgingStationList.push({
                        sortNo: this.getSortNo(0),
                        siteName: formValue.siteName,
                        siteCode: formValue.siteCode,
                        whName: formValue.whName,
                        whCode: formValue.whCode
                    });
                } else if (customerAgingStationList.length === 1 && formValue.distributionWhCode) {
                    customerAgingStationList.push({
                        sortNo: this.getSortNo(1),
                        whName: formValue.distributionWhName,
                        whCode: formValue.distributionWhCode
                    });
                }
            } else {
                if (!customerAgingStationList.length && formValue.distributionWhCode) {
                    customerAgingStationList.push({
                        sortNo: this.getSortNo(0),
                        whName: formValue.distributionWhName,
                        whCode: formValue.distributionWhCode
                    });
                }
            }
            customerAgingStationList.forEach(async (item, index) => {
                this.$set(item, 'stationType', item.stationType || 'PROPRIETARY');
                this.$set(item, 'transferFlag', [0, 1].includes(+item.transferFlag) ? item.transferFlag + '' : '');
                if (
                    (formValue.orderType === 'YS' && item.index >= 0) ||
                    (formValue.orderType !== 'YS' && item.index >= 1)
                ) {
                    if (item.whCode) {
                        const res = await this.getTransferFlag(item.whCode).finally(() => {});
                        item.transferFlagDisabled = !!res;
                    } else {
                        item.transferFlagDisabled = false;
                    }
                }
            });
            customerAgingStationList = this.getTransferFlagOptionDisabled(customerAgingStationList);
            return customerAgingStationList;
        },
        // 纯运输单第一个站点才能选择快运
        getTransferFlagOptionDisabled(stationTableList) {
            if (stationTableList.length) {
                if (!['YS', 'DO'].includes(this.formValue.orderType) && +stationTableList[0].transferFlag === 1) {
                    stationTableList[0].transferFlag = '';
                }
            }
            return stationTableList;
        },
        async getTransferFlag(whCode) {
            const params = { transferCenterCode: whCode };
            let transferFlagIsDisabled = '';
            await getTransferSite(params).then(res => {
                if (res) {
                    const data = res.data || {};
                    if (data.list && data.list.length > 0) {
                        transferFlagIsDisabled = data.list[0].operationMode;
                    }
                }
            });
            return transferFlagIsDisabled;
        },
        getAgingConfig(datailList, hour) {
            datailList.forEach(item => {
                // 节点时效从1开始
                if (!item.sortNo) { item.sortNo = 1; }
                this.$set(item, 'agingHour', item.agingHour || 0);
                this.$set(item, 'status', item.status ? item.status + '' : '');
                this.$set(item, 'begainStatus', item.begainStatus ? item.begainStatus + '' : '');
                this.$set(item, 'agingReqTime', hour + (item.agingHour || 0));
                if (+item.agingReqTime >= 24) {
                    this.$set(item, 'agingReqDay', parseInt(item.agingReqTime / 24) || 0);
                    this.$set(item, 'agingReqHour', (item.agingReqTime - item.agingReqDay * 24) || 0);
                } else {
                    this.$set(item, 'agingReqDay', 0);
                    this.$set(item, 'agingReqHour', +item.agingReqTime || 0);
                }
            });
            return datailList;
        },
        getData() {
            if (this.btnType === 'add') { return; }
            getCustomerDetail({}, this.rowData.id).then(res => {
                if (res) {
                    const data = res.data || {};
                    data.receive = data.receiveTownCode || data.receiveDistrictCode;
                    data.send = data.sendTownCode || data.sendDistrictCode;
                    data.taskType = !!data.taskType;
                    this.formValue = data;
                    const stationList = data.customerAgingStationList || [];
                    let datailList = (data.customerAgingConfigDatailList || []).sort(function(a, b) {
                        return a.status - b.status;
                    });
                    // 兼容旧的时效，没有站点仓库的 取头表 的仓库作为第一个站点，第二个站点取分拨仓
                    const customerAgingStationList = this.getStationList(stationList, this.formValue);
                    // 取时效起点的时间（时效要求 - 时效起点 = 历时）
                    let hour = (this.formValue.agingStartTime || '00:00:00').split(':')[0];
                    hour = hour.indexOf('+') > -1 ? Number(hour.split('+')[1]) + 24 : Number(hour);
                    // 时效节点配置
                    this.customerAgingConfigDatailList = datailList = this.getAgingConfig(datailList, hour);
                    this.customerAgingStationList = customerAgingStationList.map(item => {
                        item.customerAgingConfigDatailList = datailList.filter(i => i.sortNo === item.sortNo);
                        return item;
                    });
                    if (this.btnType === 'copy') {
                        this.formValue.customerAgingCode = '';
                        this.formValue.id = '';
                        this.formValue.customerAgingName += '_COPY';
                    }
                }
            });
        },
        getFirstStation() {
            const stationList = this.customerAgingStationList;
            const formValue = this.formValue;
            // 非YS的单  平台、仓库联动下面站点的第一条数据
            if (!['YS'].includes(formValue.orderType)) {
                if (stationList.length) {
                    stationList[0].siteCode = formValue.siteCode;
                    stationList[0].siteName = formValue.siteName;
                    stationList[0].whCode = formValue.whCode;
                    stationList[0].whName = formValue.whName;
                    stationList[0].stationType = stationList[0].stationType || 'PROPRIETARY';
                } else {
                    stationList.push({
                        sortNo: this.getSortNo(0),
                        siteName: formValue.siteName,
                        siteCode: formValue.siteCode,
                        whName: formValue.whName,
                        whCode: formValue.whCode,
                        stationType: 'PROPRIETARY'
                    });
                }
            }
            this.getTransferFlagOptionDisabled(stationList);
        },
        getSecondStation() {
            const formValue = this.formValue;
            // 非YS的单 分拨仓联动下面站点的第二条数据  YS的联动第一条数据
            if (['YS'].includes(formValue.orderType)) {
                if (this.customerAgingStationList.length) {
                    this.customerAgingStationList[0].whCode = formValue.distributionWhCode;
                    this.customerAgingStationList[0].whName = formValue.distributionWhName;
                } else {
                    this.customerAgingStationList.push({
                        sortNo: this.getSortNo(0),
                        whName: formValue.distributionWhName,
                        whCode: formValue.distributionWhCode
                    });
                }
            } else {
                if (!this.customerAgingStationList.length) {
                    this.customerAgingStationList = [
                        {
                            sortNo: this.getSortNo(0),
                            siteName: formValue.siteName,
                            siteCode: formValue.siteCode,
                            whName: formValue.whName,
                            whCode: formValue.whCode
                        },
                        {
                            sortNo: this.getSortNo(1),
                            whName: formValue.distributionWhName,
                            whCode: formValue.distributionWhCode
                        }
                    ];
                } else if (this.customerAgingStationList.length === 1) {
                    this.customerAgingStationList.push({
                        sortNo: this.getSortNo(1),
                        whName: formValue.distributionWhName,
                        whCode: formValue.distributionWhCode
                    });
                } else {
                    this.customerAgingStationList[1].whCode = formValue.distributionWhCode;
                    this.customerAgingStationList[1].whName = formValue.distributionWhName;
                }
            }
            this.customerAgingStationList = this.customerAgingStationList.map(item => {
                item.stationType = item.stationType || 'PROPRIETARY';
                return item;
            });
            this.getTransferFlagOptionDisabled(this.customerAgingStationList);
        },
        // 纯运输订单站点从2开始，其他从1开始，站点1联动头部平台仓库，站点2联动分拨仓
        getAdvanceValue({ data, item }) {
            this.formValue = { ...this.formValue, ...data };
            if (item.prop === 'siteName') {
                this.formValue.whCode = this.formValue.whName = '';
                this.getFirstStation();
            } else if (item.prop === 'whName') {
                this.getFirstStation();
            } else if (item.prop === 'distributionWhName') {
                this.getSecondStation();
            }
        }
    },
    mounted() {
        this.getData();
    }
};
</script>